module.exports = __webpack_public_path__ + "static/videos-59cfb1e7ad5453733d43bf9b32de7e62.jpg";